<template>
  <div>
    <base-profile />
    <div class="container-profile pb-5">
      <profile-change-password />
    </div>
  </div>
</template>
<script>
import BaseProfile from '@/components/profile/BaseProfile'
import ProfileChangePassword from '@/components/profile/ProfileChangePassword'
export default {
  components: { BaseProfile, ProfileChangePassword },
  // mounted() {
  //     document.title = 'Perfil | DEREK Tienda Online'
  //     this.$gtag.pageview(this.$route.fullPath);
  // },
}
</script>
